import classNames from 'classnames';
import React from 'react';

import { Icon, IconNewTab } from '@flixbus/honeycomb-icons-react';
import { Tag } from '@flixbus/honeycomb-react';

import { crewDataNA } from 'constants/crewDetails';
import { getPlanningUrl } from 'utils/getRunPlanningUrl';

import styles from './styles.module.css';

const RunItem = ({
	run = {},
	runLabel = 'Run',
	extraClasses = '',
	extraRunLabelClasses = '',
	isTag = false,
	smallTag = false,
	withoutLabel = false,
	onlyLink = false,
}) => {
	const handleRunClick = (runId) => {
		const planningUrl = getPlanningUrl(runId);
		window.open(planningUrl, '_blank');
	};

	const runName = run?.name || crewDataNA;

	const tagStyles = classNames({
		[styles.runTag]: true,
		[styles.noLabel]: withoutLabel,
	});

	return (
		<div className={styles.runItem}>
			{!withoutLabel && <span className={extraClasses || ''}>{`${runLabel}: `}</span>}

			{isTag && (
				<Tag small={smallTag} display="outlined" extraClasses={tagStyles}>
					<span className={extraRunLabelClasses || ''}>{runName}</span>
				</Tag>
			)}

			{!isTag && !onlyLink && (
				<span
					className={`
                    ${styles.noData}
                    ${extraRunLabelClasses || ''}
                    `}
				>
					{runName}
				</span>
			)}
			<Icon
				extraClasses={`${styles.link} ${runName === crewDataNA ? styles.disabled : ''}`}
				size={3}
				InlineIcon={IconNewTab}
				onClick={run?.id ? () => handleRunClick(run.id) : undefined}
			/>
		</div>
	);
};

export default RunItem;
